/**
 * Calculates the effective value of the userBag
 * @param {Object} params
 * @param {number} params.userBag - Base value of the userBag
 * @param {number} [params.userBagProrate] - Prorated value per month (if available)
 * @param {boolean} params.userBagRestricted - Whether the discount should be applied month by month
 * @param {Object} [params.item] - Contract item (optional)
 * @returns {number} Effective value rounded to 2 decimals
 */
export const calculateEffectiveUserBag = ({ userBag, userBagProrate, userBagRestricted, item }) => {
    if (userBagProrate === null || userBagProrate === undefined) {
        return Math.round((userBag || 0) * 100) / 100
    }
    
    if (item && item.benefit && item.benefit.monthsAvailability) {
        const activeMonthsTotal = item.benefit.monthsAvailability.filter(Boolean).length
        
        if (activeMonthsTotal > 0) {
            if (userBagRestricted === true) {
                return Math.round(userBagProrate * 100) / 100
            } else {
                const proratedDiscount = userBagProrate * activeMonthsTotal
                return Math.round(proratedDiscount * 100) / 100
            }
        }
    }
    
    return Math.round(userBagProrate * 100) / 100
}
/**
 * Returns the number of active months for a given item
 * @param {Object} item - Contract item
 * @returns {number} Number of active months (>= 0)
 */
export const getActiveMonths = (item) => {
    if (item && item.benefit && Array.isArray(item.benefit.monthsAvailability)) {
        return item.benefit.monthsAvailability.filter(Boolean).length
    }
    return 0
}
